"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionsStore = void 0;
var rxjs_1 = require("rxjs");
var utils_1 = require("@easygenerator/utils");
var permissions_store_socket_1 = __importDefault(require("./permissions-store.socket"));
var toast_1 = require("../toast");
var localization_1 = require("../localization");
var utils_2 = __importDefault(require("../../utils"));
var constants_1 = require("../../utils/logger/constants");
var HttpWrapper = utils_2.default.HttpWrapper, Logger = utils_2.default.Logger;
var RETRIES_LIMIT = 20;
var TEN_SECONDS = 10000;
var PermissionsStore = /** @class */ (function () {
    function PermissionsStore() {
        this.permissionsSubject = new rxjs_1.BehaviorSubject(utils_1.DEFAULT_USER_PERMISSIONS);
        this.retriesCount = 0;
    }
    PermissionsStore.prototype.initialize = function () {
        return __awaiter(this, void 0, void 0, function () {
            var permissions, permissionsStoreSocket, e_1, error, logger, permissions;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, HttpWrapper.get("".concat(window.permissionsServiceUrl, "/api/v1/permissions"), {
                                authScope: HttpWrapper.scope.api
                            })];
                    case 1:
                        permissions = _a.sent();
                        permissionsStoreSocket = permissions_store_socket_1.default.getInstance();
                        return [4 /*yield*/, permissionsStoreSocket.initialize()];
                    case 2:
                        _a.sent();
                        permissionsStoreSocket.connect();
                        this.refresh(permissions);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        if (this.retriesCount === RETRIES_LIMIT) {
                            error = e_1;
                            logger = Logger.getInstance();
                            logger.trackError(constants_1.LoggingType.error, error.message);
                            toast_1.toast.error((0, localization_1.localize)('permissionsFetchFailed'));
                            return [2 /*return*/];
                        }
                        if (this.retriesCount === 0) {
                            permissions = localStorage.getItem('permissions');
                            this.refresh(JSON.parse(permissions));
                        }
                        this.retriesCount++;
                        setTimeout(this.initialize.bind(this), TEN_SECONDS);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(PermissionsStore.prototype, "permissions", {
        get: function () {
            return this.permissionsSubject.asObservable();
        },
        enumerable: false,
        configurable: true
    });
    PermissionsStore.prototype.refresh = function (payload) {
        localStorage.setItem('permissions', JSON.stringify(payload));
        this.permissionsSubject.next(payload);
    };
    return PermissionsStore;
}());
exports.PermissionsStore = PermissionsStore;
exports.default = new PermissionsStore();
